module.exports = __webpack_public_path__ + "static/media/slender.f157c59b.PNG";